import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'es', label: 'Español' },
];

export default function LanguageSelector({ className = '' }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  return (
    <label className={`block ${className}`}>
      <span className="sr-only">{t('language.label')}</span>
      <select
        value={current}
        onChange={(event) => i18n.changeLanguage(event.target.value)}
        aria-label={t('language.label')}
        className="h-9 w-full rounded-md border border-border bg-background px-2 text-xs text-foreground"
        data-testid="language-selector"
      >
        {LANGUAGES.map((language) => (
          <option key={language.value} value={language.value}>{language.label}</option>
        ))}
      </select>
    </label>
  );
}
